import { createContext } from 'react'

const payContext = createContext()

export default payContext
